export default __webpack_public_path__ + "static/media/expl-nn_10_EN.594d1dcf.png";